<div class="h-row" [ngStyle]="{'border-color': withBorder ? 'var(--border)' : 'transparent'}">
  <div>
    <h3>{{row.description}}</h3>
    @if (row?.subDescription) {
      <h4>{{row.subDescription}}</h4>
    }
  </div>
  <div class="hotkey">
    @for (key of isMac ? row.keysMac : row.keysWin; track key; let i = $index) {
      <span> <span>{{key}}</span>@if (i < (isMac ? row.keysMac.length : row.keysWin.length) - 1) {
      <span>+</span>
    }</span>
  }
</div>
</div>